import React from 'react';

export default function AdminSectionLayout({ title, description, actions, children }) {
  return (
    <div className="min-h-screen sm:ml-20 ml-0 flex flex-col flex-grow bg-gray-50 font-['Montserrat']">
      <div className="bg-white border-b border-gray-200 px-8 py-6 mb-8 sm:flex justify-between items-center flex-col sm:flex-row gap-4">
        <div>
          <h1 className="sm:text-3xl text-xl font-bold text-gray-900">{title}</h1>
          {description && (
            <p className="text-gray-600 mt-1">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
            {actions}
          </div>
        )}
      </div>
      <div className="sm:px-8 px-4 pb-8">
        {children}
      </div>
    </div>
  );
}
